import React, { useState, useEffect } from 'react';
import './ViewTaxinvoice.css';

const ViewTaxInvoice = ({ invoiceData, onBack }) => {
  const [invoice, setInvoice] = useState(null);

  useEffect(() => {
    if (invoiceData) {
    
      setInvoice(invoiceData);
    }
  }, [invoiceData]);

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    
    try {
   
      const date = new Date(dateString);
      
   
      if (isNaN(date.getTime())) {
    
        const parts = dateString.split(/[-/]/);
        if (parts.length === 3) {
        
          const day = parseInt(parts[0], 10);
          const month = parseInt(parts[1], 10) - 1; 
          const year = parseInt(parts[2], 10);
          const parsedDate = new Date(year, month, day);
          
          if (!isNaN(parsedDate.getTime())) {
            return parsedDate.toLocaleDateString('en-GB');
          }
        }
        return 'N/A';
      }
      
      return date.toLocaleDateString('en-GB');
    } catch (error) {
     
      return 'N/A';
    }
  };

  const numberToWords = (num) => {
    const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    if (num === 0) return 'Zero';

    function convertTwoDigits(num) {
      if (num === 0) return '';
      if (num < 10) return ones[num];
      if (num < 20) return teens[num - 10];
      const tensPart = tens[Math.floor(num / 10)];
      const onesPart = ones[num % 10];
      return tensPart + (onesPart ? ' ' + onesPart : '');
    }

    function convertHundreds(num) {
      if (num === 0) return '';
      const hundreds = Math.floor(num / 100);
      const remainder = num % 100;
      let result = '';
      
      if (hundreds > 0) {
        result = ones[hundreds] + ' Hundred';
        if (remainder > 0) result += ' and ';
      }
      
      if (remainder > 0) {
        result += convertTwoDigits(remainder);
      }
      
      return result;
    }

    let result = '';
    let crore = Math.floor(num / 10000000);
    num = num % 10000000;
    
    let lakh = Math.floor(num / 100000);
    num = num % 100000;
    
    let thousand = Math.floor(num / 1000);
    num = num % 1000;
    
    let hundred = num;

    if (crore > 0) {
      result += convertTwoDigits(crore) + ' Crore ';
    }
    
    if (lakh > 0) {
      result += convertTwoDigits(lakh) + ' Lakh ';
    }
    
    if (thousand > 0) {
      result += convertTwoDigits(thousand) + ' Thousand ';
    }
    
    if (hundred > 0) {
      result += convertHundreds(hundred);
    }

    return result.trim();
  };

  const isIntraState = () => {
    if (!invoice?.billed_gst_no) return false;
    return invoice.billed_gst_no.substring(0, 2) === '37';
  };

  const handlePrint = () => {
    window.print();
  };


  const getInvoiceType = () => {

    if (invoice?.invoice_type) {
      return invoice.invoice_type;
    }

    if (invoice?.performa_invoice_no || invoice?.performainvoice_no) {
      return 'Performa Invoice';
    }
    

    const invoiceNo = invoice?.invoice_no || invoice?.invoice_number || '';
    if (invoiceNo.toLowerCase().includes('performa') || 
        invoiceNo.toLowerCase().includes('proforma') ||
        invoiceNo.startsWith('PI-') || 
        invoiceNo.startsWith('PRF-')) {
      return 'Performa Invoice';
    }

    return 'Tax Invoice';
  };

  if (!invoice) {
    return (
      <div className="view-invoice-container">
        <div className="loading">Loading invoice data...</div>
      </div>
    );
  }

  const invoiceType = getInvoiceType();
  const lineItems = invoice.line_items || [];
  const grossAmount = parseFloat(invoice.gross_amount || 0);
  const roundOff = parseFloat(invoice.round_off || 0);
  const cgst = parseFloat(invoice.cgst_amount || 0);
  const sgst = parseFloat(invoice.sgst_amount || 0);
  const igst = parseFloat(invoice.igst_amount || 0);
  const grandTotal = parseFloat(invoice.grand_total || 0);

    const handleBack = () => {
  
    const invoiceType = getInvoiceType();
    if (onBack) {
      onBack(invoiceType);
    }
  };

  return (
    <div className="view-invoice-container">
      <div className="view-invoice-actions no-print">
        <button onClick={handleBack} className="btn-back">← Back</button>
        
      </div>

      <div className="invoice-document">
        <div className="invoice-header">
          <div className="company-logo">
           
          </div>
          <h1 className="invoice-title">{invoiceType.toUpperCase()}</h1>
        </div>

        <div className="invoice-meta">
          <div className="invoice-number-section">
            <p><strong>Invoice No:</strong> {invoice.invoice_no || invoice.invoice_number || invoice.performa_invoice_no || invoice.performainvoice_no || 'N/A'}</p>
            <p><strong>Date:</strong> {formatDate(invoice.invoice_date || invoice.date || invoice.created_on)}</p>
          </div>
        </div>

        <div className="invoice-parties">
          <div className="party-box">
            <h3>VENDOR DETAILS</h3>
            <p className="party-name">{invoice.vendor_name || 'PIE POWER PRIVATE LIMITED'}</p>
            <p><strong>Address:</strong> {invoice.vendor_address || invoice.vendor_address1 || 'D.NO :13-66, Mangamaripeta, Bheemunipatnam, Visakhapatnam, Andhra Pradesh - 531163'}</p>
            <p><strong>GST:</strong> {invoice.vendor_gst_no || '37AALCP9321R1ZI'}</p>
            <p><strong>Vendor Code:</strong> {invoice.vendor_code || 'N/A'}</p>
          </div>

          <div className="party-box">
            <h3>BILLED TO</h3>
            <p className="party-name">{invoice.billed_name || invoice.client_name || 'N/A'}</p>
            <p><strong>PO No.:</strong> {invoice.po_no || 'N/A'}</p>
            <p><strong>PO Date:</strong> {formatDate(invoice.po_date)}</p>
            <p><strong>OLA No.:</strong> {invoice.ola_no || 'N/A'}</p>
            <p><strong>Address:</strong> {invoice.billed_address1 || invoice.billed_address || 'N/A'}</p>
            <p><strong>GST:</strong> {invoice.billed_gst_no || 'N/A'}</p>
          </div>
        </div>

        <div className="invoice-items">
          <table className="items-table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Description of Work</th>
                <th>Service Code</th>
                <th>UOM</th>
                <th>Rate (Rs.)</th>
                <th>Qty.</th>
                <th>Amount (Rs.)</th>
              </tr>
            </thead>
            <tbody>
              {lineItems.length > 0 ? (
                lineItems.map((item, index) => (
                  <tr key={index}>
                    <td className="text-center">{index + 1}</td>
                    <td>{item.description || 'N/A'}</td>
                    <td className="text-center">{item.service_code || 'N/A'}</td>
                    <td className="text-center">{item.uom || 'EA'}</td>
                    <td className="text-right">{parseFloat(item.rate || 0).toFixed(2)}</td>
                    <td className="text-center">{item.quantity || 1}</td>
                    <td className="text-right">{parseFloat(item.amount || 0).toFixed(2)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">No items available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="invoice-totals">
          <div className="totals-grid">
            <div className="total-row">
              <span>Taxable Amount:</span>
              <span>₹ {Math.round(grossAmount).toFixed(2)}</span>
            </div>
            <div className="total-row">
              <span>Round Off:</span>
              <span>₹ {roundOff.toFixed(2)}</span>
            </div>
            {isIntraState() ? (
              <>
                <div className="total-row">
                  <span>CGST @ 9%:</span>
                  <span>₹ {cgst.toFixed(2)}</span>
                </div>
                <div className="total-row">
                  <span>SGST @ 9%:</span>
                  <span>₹ {sgst.toFixed(2)}</span>
                </div>
              </>
            ) : (
              <div className="total-row">
                <span>IGST @ 18%:</span>
                <span>₹ {igst.toFixed(2)}</span>
              </div>
            )}
            <div className="total-row grand-total">
              <span>Grand Total:</span>
              <span>₹ {grandTotal.toFixed(2)}</span>
            </div>
          </div>
        </div>

        <div className="amount-words">
          <p><strong>Amount in Words:</strong> {numberToWords(Math.floor(grandTotal))} Rupees Only</p>
        </div>

        <div className="invoice-footer">
          <div className="bank-details">
            <h4>BANK DETAILS</h4>
            <img 
              src="https://tse4.mm.bing.net/th/id/OIP.a8d0G4tonetyyygHVXoHcAHaHa?pid=Api&P=0&h=220"
              alt="Union Bank Logo"
              style={{ width: '40px', height: '40px', marginBottom: '10px' }}
            />
            <p><strong>Name:</strong> PIE POWER PRIVATE LIMITED</p>
            <p><strong>Bank Name:</strong> UNION BANK OF INDIA</p>
            <p><strong>Account No:</strong> 474201010310113</p>
            <p><strong>IFSC:</strong> UBIN0547425</p>
          </div>

       
<div className="signature-section">
  <p className="signature-for">For {invoice.vendor_name || 'PIE POWER PRIVATE LIMITED'}</p>
  <div className="signature-space">
    <img 
      src="https://i.ibb.co/RpzR0W0M/Signew-1.png" 
      alt="Signature"
      className="signature-image"
      style={{
        maxWidth: '120px',
        height: 'auto',
        display: 'block',
        marginBottom: '10px'
      }}
    />
    <img 
      src="https://i.ibb.co/xqZ8CWFT/stamp.png" 
      alt="Company Stamp"
      className="stamp-image"
      style={{
        maxWidth: '80px',
        height: 'auto',
        display: 'block',
        margin: '-30px auto 10px auto'
      }}
    />
  </div>
  <p className="signature-label">Authorised Signatory</p>
</div>
        </div>
      </div>
    </div>
  );
};

export default ViewTaxInvoice;











